export const CalendarColors = ["blue", "indigo", "deep-purple", "cyan", "green", "orange", "grey darken-1"];
